import './scss/App.scoped.scss';
import { useState , useEffect, useRef } from "react";

import ScHeader from './inc/ScHeader';
import FormIncomplete from './inc/FormIncomplete';
import FormComplete from './inc/FormComplete';


function App() {
  const [pfields, setPfields] = useState([]);
  const [perror, setPerror] = useState(false);
  const [btnText, setBtnText] = useState("");
  const [pComplete, setPComplete] = useState([]);
  const [headerTxt, setHeaderTxt] = useState("Contact Sharecare to learn more.");
  const [pTxt, setPText] = useState("");
  const aId = 'a' + crypto.randomUUID().replaceAll('-','');

  useEffect(() => {
    //grab our pardot data
    let excludeClass = [
      "form-field",
      "required",
      "required-custom",
      "form-field-primary",
      "form-field-secondary",
      "dependentFieldSlave",
      "dependentField",
      "pd-select",
      "pd-text",
      "pd-checkbox",
      "pd-hidden",
      "hidden",
      "error",
      "%%form-field-css-classes%%",
      "%%form-field-dependency-css%%"
    ];
    let pcontent = document.querySelector("#p-content");
    setPerror(pcontent.querySelectorAll(".error").length > 0); 
    let pf = pcontent.querySelectorAll(".form-field");
    if(pf.length > 0) {
      let pObjTypes = [
        {p:"pd-select",t:"select"},
        {p:"pd-text",t:"text"},
        {p:"pd-checkbox",t:"checkbox"},
        {p:"pd-hidden",t:"hidden"},
        {p:"pd-textarea",t:"textarea"},
        {p:"pd-captcha", t:"captcha"}
      ];
      let pfObjs = [...pf].map(
        (pfi) => {
          let ttlist = pObjTypes.filter((x) => pfi.classList.contains(x.p))
          let ttype = ttlist.length > 0 ? ttlist[0].t : "";
          let tclass = [...pfi.classList].filter((n) => !excludeClass.includes(n));
          let wobjs = [];
          switch(ttype) {
            case "select":
              wobjs = pfi.querySelector("select");
              break;
            case "textarea":
              wobjs = pfi.querySelector("textarea");
              break;
            case "captcha":
              wobjs = pfi.querySelector("textarea");
              break;
            default:
              wobjs = pfi.querySelector("input");
          }
          let tid = wobjs ? wobjs.getAttribute("name") : "";
          let tchildren = [];
          if ( ttype === "checkbox") {
            tid = tid.slice(0,tid.lastIndexOf("_"));
            let tol = pfi.querySelector("span.value");
            let cks = [...tol.querySelectorAll("span")];
            tchildren = cks.map((ck) => {
              let cl = ck.querySelector("label").textContent;
              let ci = ck.querySelector("input");
              let cid = ci.getAttribute("name");
              return (
                {
                  id: cid,
                  label: cl,
                  obj: ck
                }
              );
            });

          }
          let tprimary = pfi.classList.contains("form-field-primary");
          let tsecondary = pfi.classList.contains("form-field-secondary");
          let trequired = pfi.classList.contains("required");
          let tdependent = pfi.classList.contains("dependentField");
          let terror = pfi.classList.contains("error");
          let terrtxt = terror ? pfi.querySelector(".error").innerHTML : "";
          let tlabel = pfi.querySelector(".field-label") ? pfi.querySelector(".field-label").textContent : "";
          return ({
            id: tid,
            type: ttype,
            obj: pfi,
            eclasses: tclass,
            label: tlabel,
            children: tchildren,
            primary: tprimary,
            secondary: tsecondary,
            required: trequired,
            dependent: tdependent,
            error: terror,
            errtxt: terrtxt
          });
        }
      );
      setPfields(pfObjs);
      let btn = document.querySelector(".submit input[type='submit']");
      if(btn) {
        setBtnText(btn.value);
      }
    } else {
      // No form fields - assume completed.  Look for text
      setPComplete([...pcontent.querySelectorAll("p")]);
    }
    window.addEventListener("message", (event) => {
      if(event.data.action && event.data.action === "pardot-int") {
        setHeaderTxt(event.data.heading ? event.data.heading : "");
        setPText(event.data.text ? event.data.text : "");
        if(event.data.btntxt && event.data.btntxt !== "") {
          setBtnText(event.data.btntxt);
        }
      }
    }, false);
    window.parent.postMessage("ready","*");
  },[]);
  if (pfields.length > 0 ) {
    return (
      <div id={aId} className="App">
        <ScHeader headerText={headerTxt} pText={pTxt}/>
        <FormIncomplete pfields={pfields} btnText={btnText} ></FormIncomplete>
      </div>
    );
  } else {
    return (
      <div className="App">
        <ScHeader headerText={headerTxt} pText={pTxt} />
        <FormComplete pComplete={pComplete}/>
      </div>
    )
  }
}

export default App;
